import React, { useEffect } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { navLinks } from "@constants/navLinks";
import useBlockScroll from "@hooks/useBlockScroll";

import NavbarLink from "../NavLink/NavLink";

import "./MobileMenu.scss";

interface MobileMenuProps {
  toggled: boolean;
  isScrolled: boolean;
  onToggle: () => void;
}

const MobileMenu = ({ toggled, isScrolled, onToggle }: MobileMenuProps) => {
  const { t } = useTranslation(["common"]);

  const classes = classNames("dropdown", { open: toggled, close: !toggled, scrolled: isScrolled });

  const { handleToggleLocked } = useBlockScroll(true);

  useEffect(handleToggleLocked, [toggled]);

  return (
    <div className={classes}>
      {navLinks.map(({ sectionID, tKey, offsetTopDesktop, offsetTopMobile }, index) => {
        return (
          <NavbarLink
            key={index}
            isMobile
            sectionID={sectionID}
            offsetTopDesktop={offsetTopDesktop}
            offsetTopMobile={offsetTopMobile}
            onClick={onToggle}
            className="dropdown-item"
          >
            {t(tKey as any)}
          </NavbarLink>
        );
      })}
    </div>
  );
};

export default MobileMenu;
